import * as React from 'react';
import { Table, Card } from 'antd';
import Utils from '../common/utils';
import strings from '../../eyeguide-localization/strings.dashboard';
import ExternalUserList from './ExternalUserList';
import TestList from '../test/TestList';
import { CustomSorter } from '../Sorter';
import '../../css/ShareList.scss';

interface IShareListProp {
    shares: any;
    shareTests: any;
    notifyShowUsersClick: any;
    externalUsers: any;
    notifyActiveClick: any;
    testListLoading: boolean;
    testListText: string;
    rtaColumns: any;
    rtaColumnData: any;
}

/**
 * State definition
 */
interface IShareListState {
    columnData: Array<any>;
    columns: Array<any>;
    pagination: any;
    loading: boolean;

}

export default class ShareList extends React.Component<IShareListProp, IShareListState> {
    
    constructor(props: IShareListProp) {
        super(props);
        this.state = {
            columnData: this.buildData(this.props.shares),
            columns: this.buildColumns(),
            loading: false,
            pagination: {},
        };
        this.notifyActiveClick = this.notifyActiveClick.bind(this);

    }

    componentDidMount() {
        const pagination = { ...this.state.pagination };
        pagination.total = this.props.shares.length;
        pagination.pageSize = 20 ;
        pagination.pageSizeOptions = ['20', '50', '75', '100'];
        pagination.showSizeChanger = true ;  
        pagination.showTotal = function (total: any) {
            return strings.formatString(strings.lsTotalShares, total);
        };
        this.setState({
            columnData: this.buildData(this.props.shares),
            columns: this.buildColumns(),
            loading: false,
            pagination: pagination,
        });
    }

    render() {
        return(
            <Table
                className="ShareList"
                columns={this.state.columns}
                dataSource={this.state.columnData}
                loading={this.state.loading}
                pagination={this.state.pagination}
                expandedRowRender={this._expandRowRender}
                onExpand={this.onExpand}
                expandRowByClick={true}
            />
        );
    }

    /**
     * Render function called when row is expanded. Returns the HTML elements to display
     */
    _expandRowRender = (record: any, expanded: any, expandedRowKeys: any) => {
        console.log('_expandRowRender', record);
        console.log('_expandRowRender', expanded);
        console.log('expandedRowKeys', expandedRowKeys);     
        console.log('his.props.externalUsers', this.props.externalUsers)  ;
        return(
            <div>
            <Card title={strings.lsShareesTxt} bordered={false}>
            <ExternalUserList 
                users={this.props.externalUsers.has(record.shareid) ? 
                            this.props.externalUsers.get(record.shareid) : []}
                notifyActiveClick={this.notifyActiveClick}

            />
            </Card>
             <Card title={strings.lsSharedTestTxt} bordered={false}>
                <TestList
                    organizationID=""
                    rosterID=""
                    tests={this.props.shareTests.has(record.shareid) ? this.props.shareTests.get(record.shareid) : []}
                    notifySelectedTests={undefined}
                    organizationName={''}
                    enableTitleSpace={false}
                    pagination={false}
                    sorting={false}
                    showAthelete={true}
                    showDownloadAction={true}
                    loading={this.props.testListLoading}
                    emptyText={this.props.testListText}
                    showEditAction={false}
                    notifyTestUpdated={undefined}
                    notifyTestDownload={() => this.setState({loading: !this.state.loading})}
                />
             </Card>
            {record.returntoactivity === 1 ? 
            <Card  title={strings.lsSharedReturnToActivityTxt} bordered={false}>
                <Table
                    columns={this.props.rtaColumns} 
                    dataSource={this.props.rtaColumnData.get(record.shareid)} 
                    rowClassName={(rec, index) => 'rows'}
                    pagination={false}
                    loading={this.state.loading}
                    locale={{ emptyText: '' }} 
                />
            </Card> 

                : '' }
            </div>
        );
    }
  
    /**
     * This function builds the data required by the Table component to display the Users
     * @param users Users array containing the users to be dispalyed
     */
    private buildData(shares: Array<any>) {
        let columnData: Array<any> = [];
        shares.forEach( (element: any) => {
            console.log('build', element );
            let data = {
                shareid        : element.shareid,
                returntoactivity: element.returntoactivity,
                organization  : element.organization,
                time         : Utils.getDate(element.time),
                totalSharees    : element.totalSharees,
                totalTests      : element.totalTests 
            };
            columnData.push(data);
        }); 
        console.log('columnData', columnData);
        return columnData;
    }
  
    private buildColumns() {
        let columns = [
            {
                title: strings.lsDateTxt,
                dataIndex: 'time',
                sorter: (a: any, b: any) => a.time.localeCompare(b.time),
                className: 'rows',
                onHeaderCell: (column) => {
                    return {
                        onClick: () => {
                            this.setState({
                                columns: CustomSorter.cleanAndToggleSortOrder(this.state.columns, column.dataIndex)
                            });
                        }
                    };
                }
            },
            {
                title: strings.lsOrgTxt,
                dataIndex: 'organization',
                sorter: (a: any, b: any) => a.organization.localeCompare(b.organization),
                className: 'rows',
                render: (text: any) => (
                    <div
                        className={'clipped'}
                        title={text}
                        style={{width: '150px'}}
                    >
                    {text}
                    </div>),
                onHeaderCell: (column) => {
                    return {
                        onClick: () => {
                            this.setState({
                                columns: CustomSorter.cleanAndToggleSortOrder(this.state.columns, column.dataIndex)
                            });
                        }
                    };
                }
            },    
            {
                title: strings.lsTotalSharees,
                dataIndex: 'totalSharees',
                // sorter: (a: any, b: any) => a.totalSharees.localeCompare(b.totalSharees),
                className: 'row'
            },
            {
                title: strings.lsTotalTests,
                dataIndex: 'totalTests',
                // sorter: (a: any, b: any) => a.totalTests.localeCompare(b.totalTests),                
            },

        ];
        return columns;
    }

    /**
     * Notifies Profiles Component to fetch last baseline tests for the record
     * @param record Record that is expanded
     */
    private getExternalUsers(record: any) {
        this.props.notifyShowUsersClick(record.shareid);
    }

    /**
     * Fetches the test list for the player whose profile is expanded
     * This function is called by list itself
     */
    private onExpand = (expanded: any, record: any) => {
        console.log('onExpand', this.props.externalUsers);
        if (expanded) {
            if (!this.props.externalUsers.has(record.shareid)) {
                this.getExternalUsers(record);
            }
        }
    }

    private notifyActiveClick(active: string, shareId: string, shareUserId: string, record: any) {
        this.props.notifyActiveClick(active, shareId, shareUserId, record);
    }

}


// WEBPACK FOOTER //
// ./src/components/user/ShareList.tsx